import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import MainNavbar from "components/Navbars/MainNavbar";
import PrivacyPolicy from "views/PrivacyPolicy";

const ScrollToTop = ({ children }) => {
  const { pathname } = window.location;

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
}

const App = () => {
  const navigate = useNavigate();

  return (
    <TransitionGroup>
      <CSSTransition
        timeout={{
          enter: 400,
          exit: 400,
        }}
        classNames="page"
        unmountOnExit
      >
        <ScrollToTop>
          <Routes>
            <Route path="/privacy-policy" element={<PrivacyPolicy navigate={navigate} />} />
            <Route path="*" element={<MainNavbar navigate={navigate} />} />
          </Routes>
        </ScrollToTop>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default App;
